import React, { PropsWithChildren } from "react";
import { ProjectLinkStyle as S } from "./ProjectLink.style";
import { useObservable } from "@rsm";
import { getClientService } from "services/client.service";
import { ApiSchema } from "@api-types";

export const getProjectLink = (
  project: Pick<ApiSchema.Project, "statusCode" | "id"> | Pick<ApiSchema.ProjectDto, "statusCode" | "id">,
  teamId?: number,
) => {
  const status = project?.statusCode || 0;
  const teamPath = teamId ? `/${teamId}/` : "";

  if (status === 50) return `${teamPath}project/${project.id}/review`;
  if (status < 200) return `${teamPath}project/${project.id}`;
  if (status <= 400) return `${teamPath}project-surveys/${project.id}`;
  if (status >= 600) return `${teamPath}results/${project.id}`;
  return "#";
};

export const ProjectLink: React.FC<
  PropsWithChildren<{
    projectId: number;
    statusCode: number;
    teamId?: number;
    className?: string;
    openInNewTab?: boolean;
  }>
> = ({ projectId, statusCode, children, teamId: clientId, className, openInNewTab }) => {
  const client = useObservable(getClientService().client$);
  const projectLink = getProjectLink({ statusCode, id: projectId });

  return (
    <>
      <S.ProjectLink
        className={className}
        to={`/${clientId ?? client?.id}/${projectLink}`}
        target={openInNewTab ? "_blank" : undefined}
      >
        {children}
      </S.ProjectLink>
    </>
  );
};
